import { useCallback, useEffect, useRef } from "react";

import { WorkspaceSessionManager } from "@/utils/workspace-session";

export function useInactivityTimer(onInactive: () => void, timeout = 30 * 60 * 1000) {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(onInactive, timeout);
    WorkspaceSessionManager.updateActivity();
  }, [onInactive, timeout]);

  useEffect(() => {
    const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];

    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [resetTimer]);
}
